/* =========================================================
   LANDING PRIMEIRA COMPRA — /collections/primeira-compra
   Carregado com defer só em templates/collection.primeira-compra.json.
   Sem dependências: usa o cart-drawer e o pubsub (cart-update) do próprio tema.
   ========================================================= */

/* ---------- Núcleo: toast, carrinho e barra de progresso ---------- */
(function () {
  'use strict';

  const pc = (window.cbPc = window.cbPc || {});
  const SOURCE = 'cb-primeira-compra';
  const STORAGE_KEY = 'cbPcCartbar';

  pc.reducedMotion = function () {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  /* Toast: criado no carregamento para o role="status" já existir quando a mensagem mudar */
  const toastEl = document.createElement('div');
  toastEl.className = 'pc-toast';
  toastEl.setAttribute('role', 'status');
  toastEl.innerHTML = '<i aria-hidden="true"></i><span></span>';
  document.body.appendChild(toastEl);
  let toastTimer;

  pc.toast = function (message) {
    toastEl.querySelector('span').textContent = message;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-visible'), 2600);
  };

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  }

  /* ---------- Barra de progresso (frete grátis / brinde) ---------- */
  const bar = document.querySelector('[data-pc-cartbar]');
  const cfg = bar
    ? {
        freeShip: Number(bar.dataset.freeShip) || 0,
        gift: Number(bar.dataset.gift) || 0,
        percent: Number(bar.dataset.percent) || 0,
        coupon: bar.dataset.coupon || '',
        currency: bar.dataset.currency || 'BRL',
      }
    : null;
  const currencyFormat = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: cfg ? cfg.currency : 'BRL' });
  const money = (cents) => currencyFormat.format(cents / 100);

  function showBar(visible) {
    if (!bar) return;
    bar.classList.toggle('is-visible', visible);
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    if (visible) bar.removeAttribute('inert');
    else bar.setAttribute('inert', '');
    document.body.classList.toggle('has-cartbar', visible);
    const wa = document.getElementById('whatsapp-button') || document.querySelector('.whatsapp-button');
    if (wa) {
      wa.classList.toggle('whatsapp-button--raised', visible);
    }
  }

  function renderBar(subtotal) {
    if (!bar) return;
    const { freeShip, gift } = cfg;
    
    // Progresso em 2 etapas:
    // 0 até freeShip (R$ 299) -> 0% a 60%
    // freeShip até gift (R$ 399) -> 60% a 100%
    let progressPct = 0;
    if (subtotal <= 0) {
      progressPct = 0;
    } else if (subtotal < freeShip) {
      progressPct = (subtotal / freeShip) * 60;
    } else if (subtotal < gift) {
      progressPct = 60 + ((subtotal - freeShip) / (gift - freeShip)) * 40;
    } else {
      progressPct = 100;
    }
    progressPct = Math.min(100, Math.max(0, progressPct));

    const fill = bar.querySelector('[data-pc-cart-fill]');
    if (fill) fill.style.width = progressPct + '%';

    const markShip = bar.querySelector('[data-pc-mark="ship"]');
    const markGift = bar.querySelector('[data-pc-mark="gift"]');
    const labelShip = bar.querySelector('[data-pc-label="ship"]');
    const labelGift = bar.querySelector('[data-pc-label="gift"]');

    if (markShip) {
      markShip.style.left = '60%';
      markShip.classList.toggle('is-hit', subtotal >= freeShip);
    }
    if (markGift) {
      markGift.style.left = '100%';
      markGift.classList.toggle('is-hit', subtotal >= gift);
    }
    if (labelShip) {
      labelShip.style.left = '60%';
      labelShip.classList.toggle('is-hit', subtotal >= freeShip);
    }
    if (labelGift) {
      labelGift.style.left = '100%';
      labelGift.classList.toggle('is-hit', subtotal >= gift);
    }

    let msg;
    if (subtotal < freeShip) {
      msg = `Faltam <b>${money(freeShip - subtotal)}</b> para o <b>frete grátis</b>`;
    } else if (subtotal < gift) {
      msg = `Você liberou <b>frete grátis</b>! Falta <b>${money(gift - subtotal)}</b> para o <b>brinde</b> 🎁`;
    } else {
      msg = `Você liberou <b>frete grátis</b> e <b>brinde surpresa</b> <span aria-hidden="true">🎉</span>`;
    }
    const withCoupon = Math.round(subtotal * (1 - cfg.percent / 100));
    const coupon = cfg.coupon ? ` · com cupom ${money(withCoupon)}` : '';
    const msgEl = bar.querySelector('[data-pc-cart-msg]');
    if (msgEl) {
      msgEl.innerHTML = `${msg}<span class="pc-cartbar__sub">Subtotal ${money(subtotal)}${coupon}</span>`;
    }
  }

  pc.refreshCart = async function (reveal) {
    if (!bar) return;
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      const subtotal = typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : cart.total_price;
      renderBar(subtotal);
      if (cart.item_count === 0) {
        showBar(false);
        try {
          sessionStorage.removeItem(STORAGE_KEY);
        } catch (e) {}
      } else if (reveal) {
        showBar(true);
      }
    } catch (e) {
      /* sem /cart.js a barra só não atualiza */
    }
  };

  /* ---------- Adicionar ao carrinho ---------- */
  // Mesmo fluxo do product-form do tema: adiciona e deixa o cart-drawer renderizar header + gaveta
  async function refreshCartIcon() {
    const icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    const res = await fetch(`${window.location.pathname}?sections=cart-icon-bubble`);
    const sections = await res.json();
    const html = new DOMParser()
      .parseFromString(sections['cart-icon-bubble'], 'text/html')
      .querySelector('.shopify-section');
    if (html) icon.innerHTML = html.innerHTML;
  }

  async function addToCart(variantId, btn) {
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const label = btn.innerHTML;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.textContent = 'Adicionando…';

    try {
      const body = { items: [{ id: Number(variantId), quantity: 1 }] };
      if (cart && cart.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map((s) => s.section || s.id);
        body.sections_url = window.location.pathname;
        if (cart.setActiveElement) cart.setActiveElement(btn);
      }
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok) {
        pc.toast(data.description || 'Não foi possível adicionar o produto.');
        return;
      }

      const item = Object.assign({}, data.items && data.items[0], { sections: data.sections });
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, productVariantId: variantId, cartData: item });
      }
      if (cart && cart.renderContents && data.sections) {
        cart.classList.remove('is-empty');
        cart.renderContents(item);
      } else {
        await refreshCartIcon();
      }
      pc.toast('Produto adicionado ao carrinho');

      try {
        sessionStorage.setItem(STORAGE_KEY, '1');
      } catch (e) {}
      await pc.refreshCart(true);
    } catch (e) {
      pc.toast('Erro de comunicação com o carrinho. Tente de novo.');
    } finally {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      btn.innerHTML = label;
    }
  }

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-pc-add]');
    if (!btn || btn.disabled) return;
    event.preventDefault();
    addToCart(btn.dataset.pcAdd, btn);
  });

  // Alterações feitas na gaveta do carrinho (quantidade, remover) também atualizam a barra
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.source === SOURCE) return;
      pc.refreshCart(false);
    });
  }

  // Na carga inicial da página: apenas busca o carrinho em segundo plano, SEM exibir a barra
  // A barra só aparece após a ação voluntária de adicionar itens
  pc.refreshCart(false);
})();

/* ---------- Hero: copiar cupom ---------- */
(function () {
  'use strict';

  const pc = window.cbPc;

  function legacyCopy(text) {
    const field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    let ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (e) {}
    field.remove();
    return ok;
  }

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-pc-copy]');
    if (!btn) return;
    const code = btn.dataset.pcCopy;
    if (code) {
      try {
        fetch('/discount/' + encodeURIComponent(code), { mode: 'no-cors' }).catch(() => {});
      } catch (e) {}
    }
    let ok = false;
    try {
      await navigator.clipboard.writeText(code);
      ok = true;
    } catch (e) {
      ok = legacyCopy(code);
    }

    const label = btn.querySelector('[data-pc-copy-label]');
    if (label) {
      if (!label.dataset.default) label.dataset.default = label.textContent;
      label.textContent = ok ? 'Copiado!' : label.dataset.default;
    }
    btn.classList.toggle('is-copied', ok);
    clearTimeout(btn._pcTimer);
    btn._pcTimer = setTimeout(() => {
      btn.classList.remove('is-copied');
      if (label) label.textContent = label.dataset.default;
    }, 2200);

    pc.toast(ok ? `Cupom ${code} copiado!` : `Use o cupom ${code} no checkout`);
  });
})();

/* ---------- Carrossel "Para começar": setas ---------- */
(function () {
  'use strict';

  const pc = window.cbPc;

  document.querySelectorAll('[data-pc-rail]').forEach((root) => {
    const track = root.querySelector('[data-pc-rail-track]');
    const prev = root.querySelector('[data-pc-rail-prev]');
    const next = root.querySelector('[data-pc-rail-next]');
    if (!track || !prev || !next) return;

    // aria-disabled em vez de disabled: o botão continua focável quando chega ao fim
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      prev.setAttribute('aria-disabled', track.scrollLeft <= 2 ? 'true' : 'false');
      next.setAttribute('aria-disabled', track.scrollLeft >= max - 2 ? 'true' : 'false');
    };
    const go = (dir, btn) => {
      if (btn.getAttribute('aria-disabled') === 'true') return;
      track.scrollBy({ left: (track.clientWidth / 2) * dir, behavior: pc.reducedMotion() ? 'auto' : 'smooth' });
    };

    prev.addEventListener('click', () => go(-1, prev));
    next.addEventListener('click', () => go(1, next));
    let frame;
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    };
    track.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    schedule();
  });
})();

/* ---------- Catálogo: filtros, ordenação e "Carregar mais" (Section Rendering API) ---------- */
(function () {
  'use strict';

  const pc = window.cbPc;
  const root = document.querySelector('[data-pc-catalog]');
  if (!root) return;

  const sectionId = root.dataset.sectionId;
  const find = (selector, scope) => (scope || root).querySelector(selector);
  let controller;
  let lastSearch = window.location.search;

  // URL da página sem section_id e sem page (filtro/ordem novos sempre começam na página 1)
  function pageUrl(href) {
    const url = new URL(href, window.location.origin);
    url.searchParams.delete('section_id');
    url.searchParams.delete('page');
    return url.pathname + url.search;
  }

  async function fetchCatalog(href) {
    if (controller) controller.abort();
    controller = new AbortController();
    const url = new URL(href, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    const res = await fetch(url.toString(), { signal: controller.signal });
    if (!res.ok) throw new Error('HTTP ' + res.status);
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const fresh = doc.querySelector('[data-pc-catalog]');
    if (!fresh) throw new Error('seção não encontrada');
    return fresh;
  }

  function updateMore(fresh) {
    const box = find('[data-pc-more]');
    const next = find('[data-pc-more]', fresh);
    if (!box || !next) return;
    find('[data-pc-more-text]').textContent = find('[data-pc-more-text]', next).textContent;
    find('[data-pc-more-bar]').style.width = find('[data-pc-more-bar]', next).style.width;
    const btn = find('[data-pc-more-btn]');
    const nextBtn = find('[data-pc-more-btn]', next);
    if (btn && nextBtn) btn.setAttribute('href', nextBtn.getAttribute('href'));
    else if (btn) btn.remove();
    else if (nextBtn) box.appendChild(nextBtn);
  }

  function setLoading(on) {
    root.classList.toggle('is-loading', on);
    const grid = find('[data-pc-grid]');
    if (on) grid.setAttribute('aria-busy', 'true');
    else grid.removeAttribute('aria-busy');
  }

  async function applyUrl(href, push) {
    const target = pageUrl(href);
    const active = document.activeElement;
    const focusKey = active && active.closest('[data-pc-filter]') ? active.dataset.pcKey : null;
    setLoading(true);
    try {
      const fresh = await fetchCatalog(target);

      const chips = find('[data-pc-chips]');
      const freshChips = find('[data-pc-chips]', fresh);
      if (chips && freshChips) chips.innerHTML = freshChips.innerHTML;

      // select e filtros ocultos do formulário (o select não é trocado para não perder o foco)
      const form = find('[data-pc-sort-form]');
      const freshForm = find('[data-pc-sort-form]', fresh);
      if (form && freshForm) {
        form.querySelectorAll('input[type="hidden"]').forEach((input) => input.remove());
        freshForm.querySelectorAll('input[type="hidden"]').forEach((input) => form.prepend(input));
        find('[data-pc-sort]').value = find('[data-pc-sort]', freshForm).value;
      }

      find('[data-pc-grid]').innerHTML = find('[data-pc-grid]', fresh).innerHTML;
      updateMore(fresh);

      if (push) window.history.pushState({ pcCatalog: true }, '', target);
      lastSearch = window.location.search;

      if (focusKey) {
        const again = root.querySelector(`[data-pc-key="${CSS.escape(focusKey)}"]`);
        if (again) again.focus({ preventScroll: true });
      }
      if (root.getBoundingClientRect().top < 0) {
        root.scrollIntoView({ behavior: pc.reducedMotion() ? 'auto' : 'smooth', block: 'start' });
      }
    } catch (err) {
      if (err.name !== 'AbortError') window.location.href = target;
    } finally {
      setLoading(false);
    }
  }

  async function loadMore(btn) {
    const label = btn.textContent;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Carregando…';
    try {
      const fresh = await fetchCatalog(btn.href);
      const items = Array.from(find('[data-pc-grid]', fresh).children);
      find('[data-pc-grid]').append(...items);
      updateMore(fresh);
      // leva o foco para o primeiro produto novo, para quem navega pelo teclado
      const firstLink = items[0] && items[0].querySelector('.pc-card__title a');
      if (firstLink) firstLink.focus({ preventScroll: true });
    } catch (err) {
      if (err.name !== 'AbortError') window.location.href = btn.href;
    } finally {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      btn.textContent = label;
    }
  }

  function sortUrl(form) {
    const url = new URL(form.action, window.location.origin);
    new FormData(form).forEach((value, key) => url.searchParams.append(key, value));
    return url.toString();
  }

  root.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-pc-filter]');
    if (chip) {
      event.preventDefault();
      if (!chip.classList.contains('is-on')) applyUrl(chip.href, true);
      return;
    }
    const more = event.target.closest('[data-pc-more-btn]');
    if (more) {
      event.preventDefault();
      loadMore(more);
    }
  });

  root.addEventListener('change', (event) => {
    if (event.target.matches('[data-pc-sort]')) applyUrl(sortUrl(event.target.form), true);
  });

  root.addEventListener('submit', (event) => {
    if (!event.target.matches('[data-pc-sort-form]')) return;
    event.preventDefault();
    applyUrl(sortUrl(event.target), true);
  });

  // Voltar/avançar do navegador: só recarrega a grade quando os filtros mudaram (ignora âncoras #)
  window.addEventListener('popstate', () => {
    if (window.location.search !== lastSearch) applyUrl(window.location.href, false);
  });
})();
